// eslint-disable-next-line max-classes-per-file
export interface RequestAllFlightInterface {
  countrySlug: string;
  citySlug?: string;
  isGroup?: boolean;
}

export class Airport {
  name: string = "";

  slug: string = "";

  iataCode: string = "";

  character?: string;

  constructor(data?: Airport) {
    this.name = data?.name ?? this.name;
    this.slug = data?.slug ?? this.slug;
    this.iataCode = data?.iataCode ?? this.iataCode;
    this.character = data?.character ?? this.character;
  }
}

export class AirportsData {
  airports: Airport[] = [];

  countryName: string = "";

  cityName: string = "";

  groupCharacter?: string[] | null;

  constructor(data?: AirportsData) {
    this.cityName = data?.cityName ?? this.cityName;
    this.countryName = data?.countryName ?? this.countryName;
    this.airports = (data?.airports || []).map((item) => new Airport(item));
    this.groupCharacter = data?.groupCharacter || null;
  }
}

export class ResponseAllFlight {
  status: boolean = false;

  message: string = "";

  data: AirportsData = new AirportsData();

  constructor(data?: ResponseAllFlight) {
    this.data = new AirportsData(data?.data);
    this.message = data?.message ?? this.message;
    this.status = data?.status ?? this.status;
  }
}
